import ActionType from 'actions/ActionType'

export default (
	state = {
		dialogOpen: false,
		usersToAddSelectValue: [],
		usersInAssignmentPool: null,
		recentlyAssignedContacts: {},
	},
	action,
) => {
	const switchObj = {
		[ActionType.RoundRobin.TOGGLE_DIALOG]: () => {
			return {
				...state,
				dialogOpen:
					typeof action.payload === 'boolean'
						? action.payload
						: !state.dialogOpen,
			}
		},
		[ActionType.RoundRobin.SELECT_USER_TO_ADD]: () => {
			return {
				...state,
				usersToAddSelectValue: action.payload,
			}
		},
	}

	return switchObj?.[action?.type] ? switchObj[action?.type]() : state
}
